import { render } from "./DolarIcon.vue?vue&type=template&id=7185f4c9"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DolarIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7185f4c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7185f4c9', __exports__)) {
    api.reload('7185f4c9', __exports__)
  }
  
  module.hot.accept("./DolarIcon.vue?vue&type=template&id=7185f4c9", () => {
    api.rerender('7185f4c9', render)
  })

}


export default __exports__